
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(222|445)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
